import { IActivityDetail } from './iactivity-detail';
export interface IActivityStatus {
    activityStatusIdentifier: string;
    display: string;
    definition: string;
    tenantId: number;
    language: string;
    activityDetail: IActivityDetail[];
}